<template>
    <CouponsComponent />
</template>
<script>
import CouponsComponent from "@/components/coupons";

export default {
    components: { CouponsComponent },
}
</script>